import { DOWNLOADFILE, GET } from "../../API/get";
import { POST } from "../../API/post";
import { getUserInfo } from "../../storage";

export const fetchFtmEarnings = async (ftm_id) => {
    const response = await GET(`v3/ftm-valuations/payment/information/${ftm_id}`);
    if (response.status === "Success") {
        return response;
    }

    return null;
}

export const fetchFtmValuations = async (ftm_id, Valuation_id) => {
    let URL = `v3/ftm-valuations/${ftm_id}`;
    if(Valuation_id > 0){
        URL = `v3/ftm-valuations/${ftm_id}?valuation_id=${Valuation_id}`;
    }
    
    const response = await GET(URL);
    if (response.status === "Success") {
        return response;
    }

    return null;
}

export const createValuation = async (ftm_id) => {
    const userInfo = getUserInfo();
    const response = await POST("v3/ftm-valuations", {
        ftm_id: ftm_id,
        admin_id: userInfo.admin_id
    });

    return response?.status === "Success" ? response : null
}

export const fetchFtmValuationsHistory = async (ftm_id, page) => {
    const response = await GET(`v3/ftm-valuations/history/${ftm_id}/${page}`);
    if (response.status === "Success") {
        return response;
    }

    return null;
}

export const downloadValuationReport = async (valuation_id) => {
    await DOWNLOADFILE(`v3/ftm-valuations/report/${valuation_id}`);
};